export const ReportStatuses = {
  STARTED: 'STARTED',
  FINISHED: 'FINISHED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  QUEUED: 'QUEUED',
  ERROR: 'ERROR',
  DELETING: 'DELETING',
} as const;
